import { render, staticRenderFns } from "./CountryDetailComponent.vue?vue&type=template&id=255fdaf0&"
import script from "./CountryDetailComponent.vue?vue&type=script&lang=js&"
export * from "./CountryDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports